import { ENV } from './environment';

export const HOST = `https://brain.${ENV}.saleswhale.com`;
const NAMESPACE = `operator_api/v1`;
export const ENDPOINT = `${HOST}/${NAMESPACE}`;
